import dayjs from 'dayjs';
import prettify from 'html-prettify';
import cloneDeep from 'lodash/cloneDeep';

import { undefDestroy, UnescapeHtml } from '@webapp/common/lib/utils';

import type { EmailDetail, EmailDetailStatus } from './email-detail';
import { initialEmailDetail } from './email-detail';
import type { Mail, MailGroup, MailStatus, MailType } from './mailing';
import { initialMail, initialMailParams } from './mailing';
import type { Recipient } from './recipient';
import type { Stat } from './stat';

export const mapEmailDetail = ({ RECIPIENT, START_TIME, STATUS, STATUS_DATE, UNSUBS }: any): EmailDetail => ({
    ...cloneDeep(initialEmailDetail),
    recipient: RECIPIENT,
    startDatetime: START_TIME,
    unsubscribed: UNSUBS,
    status: STATUS as EmailDetailStatus,
    responseDatetime: STATUS_DATE,
});
export const mapMail = ({
    CONFIRMED,
    FROM,
    ID,
    IDENTIFICATION,
    PARAMS,
    READED_QNT,
    START_TIME,
    STATUS,
    TEMPLATE,
    TITLE,
    TOTAL_QNT,
    TYPE,
}: any): Mail => {
    return {
        ...cloneDeep(initialMail),
        id: ID,
        title: TITLE,
        status: STATUS as MailStatus,
        bindMail: Boolean(IDENTIFICATION),
        senderEmail: FROM,
        senderConfirm: CONFIRMED === 1,
        params: (() => {
            const params = PARAMS ? JSON.parse(PARAMS) : cloneDeep(initialMailParams);

            let fullHtml = UnescapeHtml(params.fullHtml);
            fullHtml = fullHtml.split('><').join(`>\n\t<`);
            fullHtml = prettify(fullHtml);
            params.fullHtml = fullHtml;
            params.expireDate = params.expireDate ? dayjs(params.expireDate) : undefined;

            return params;
        })(),
        template: TEMPLATE,
        mailType: TYPE as MailType,
        sendDatetime: dayjs.utc(START_TIME),
        replyAmount: READED_QNT,
        emailsAmount: TOTAL_QNT,
    };
};
export const reverseMapMail = ({ bindMail, senderEmail, status, template, title, who }: Partial<Mail>): any =>
    undefDestroy({
        title,
        status,
        who,
        identification: typeof bindMail !== 'undefined' ? (bindMail ? 1 : 0) : undefined,
        from: senderEmail,
        template,
    });

interface MailGroupResponse {
    ID: number;
    NAME: string;
    EMAILS: Array<{
        [key: string]: string;
    }>;
    HIDDEN: number;
}

export const mapGroup = ({ EMAILS, HIDDEN, ID, NAME }: MailGroupResponse): MailGroup => ({
    id: ID,
    name: NAME,
    emails: EMAILS,
    hidden: Boolean(HIDDEN),
});

export interface RecipientResponse {
    ID: number;
    RECIPIENT: string;
}

export const mapRecipient = ({ ID, RECIPIENT }: RecipientResponse): Recipient => ({
    id: ID,
    email: RECIPIENT,
});

export const mapStat = ({
    ANSWERED_QNT,
    NOTSENT_QNT,
    READED_QNT,
    SENT_QNT,
    TOTAL_QNT,
    UNREADED_QNT,
    UNSUBS_QNT,
}: any): Stat => ({
    answered: ANSWERED_QNT,
    total: TOTAL_QNT,
    sent: SENT_QNT,
    notSent: NOTSENT_QNT,
    read: READED_QNT,
    notRead: UNREADED_QNT,
    unsubscribed: UNSUBS_QNT,
});
